export const baseurl = 'https://digitalize.aiyd88.com'
export const appid = 'wx8e4c6655672ef107'